// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"7f8a5876","734":"f047e1f1"}[chunkId] + ".chunk.js";
};